// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer-Disclaimer-disclaimer-93PJc7TE"};